import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

const KEY = "orb-theme";
export const getTheme = () => localStorage.getItem(KEY) || "light";
export const applyTheme = (t) => {
  document.documentElement.classList.toggle("light", t === "light");
  document.documentElement.classList.toggle("dark", t !== "light");
};
applyTheme(getTheme());

export const useTheme = () => {
  const [t, setT] = useState(getTheme);
  useEffect(() => {
    const on = () => setT(getTheme());
    window.addEventListener("orb-theme", on);
    return () => window.removeEventListener("orb-theme", on);
  }, []);
  return t;
};

export const ThemeToggle = () => {
  const t = useTheme();
  const flip = () => {
    const n = t === "light" ? "dark" : "light";
    localStorage.setItem(KEY, n);
    applyTheme(n);
    window.dispatchEvent(new Event("orb-theme"));
  };
  return (
    <button data-testid="button-theme-toggle" onClick={flip} title={`Switch to ${t === "light" ? "dark" : "light"} theme`}
      className="flex h-7 items-center gap-1.5 rounded border border-slate-700 px-2 text-[11px] text-slate-300 transition-colors hover:border-indigo-500 hover:text-indigo-200">
      {t === "light" ? <Moon size={12} /> : <Sun size={12} />} {t === "light" ? "Dark" : "Light"}
    </button>
  );
};
